import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-custom-modal',
  templateUrl: './custom-modal.component.html',
})
export class CustomModalComponent {
  constructor(public bsModalRef: BsModalRef) {}

  @Input() title!: string;
  @Input() subtitle: string;
  @Input() hideCancel: boolean = false;
  @Input() hideSave: boolean = false;
  @Input() cancelLabel = 'Cancelar';
  @Input() cancelDisabled: boolean = false;
  @Input() saveLabel = 'Salvar Alterações';
  @Input() saveDisabled: boolean = false;
  @Input() customButtonLabel = 'Salvar & Imprimir';
  @Input() customButtonDisabled: boolean = false;
  @Input() showCustomButton: boolean = false;
  @Input() roundedBody: boolean = false;
  @Input() showReturn: boolean = false;
  @Input() buttonImage: string = undefined;
  @Input() showDelete: boolean = false;

  @Output() onDeleteClick = new EventEmitter<number>();
  @Output() onCancelClick = new EventEmitter<number>();
  @Output() onSaveClick = new EventEmitter<number>();
  @Output() onCustomButtonClick = new EventEmitter<number>();
  @Output() onCloseClick = new EventEmitter<number>();
  @Output() onReturnClick = new EventEmitter<number>();

  public close() {
    this.bsModalRef.hide();
  }
}
